export default __webpack_public_path__ + "static/title-how-to-play-76ab783f49773f3e98719db932973c71.png";